import {Component, MeshComponent, Object3D, Material} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {FlatMaterial} from '../types/materials.js';

/**
 * vignette
 */
export class Vignette extends Component {
    static TypeName = 'vignette';

    /* Time in seconds the vignette will take to fade in after movement starts */
    @property.float(0.5)
    fadeIn!: number;

    /* Time in seconds the vignette will take to fade out after movement stopped */
    @property.float(0.1)
    fadeOut!: number;

    private moving = false;
    private factor = 0.0;

    private vignetteMesh: MeshComponent | null = null;
    private vignetteMaterial: Material | null = null;
    private vignetteColor = new Float32Array(4);

    start() {
        this.vignetteMesh = this.object.getComponent(MeshComponent);
        if(!this.vignetteMesh) {
            throw new Error("Missing mesh component on 'meshObject'");
        }
        this.vignetteMaterial = this.vignetteMesh.material;
    }

    update(dt: number) {
        if(this.moving) {
            this.factor = Math.min(this.factor + dt/this.fadeIn, 1.0);
        } else {
            this.factor = Math.max(this.factor - dt/this.fadeOut, 0.0);
        }

        this.vignetteColor[3] = this.factor;
        (this.vignetteMaterial! as FlatMaterial).color = this.vignetteColor;

        /* Disable the mesh if alpha is below visible */
        this.vignetteMesh!.active = this.factor >= 0.01;
    }

    startMoving() {
        this.moving = true;
    }

    stopMoving() {
        this.moving = false;
    }
}
